import { safeParseJson } from '../utils/safeParseJson';

const KEY = 'dg_sync_log_v1';
const MAX_ENTRIES = 40;

export type SyncLogLevel = 'info' | 'success' | 'error';

export type SyncLogEntry = {
  id: string;
  at: number;
  level: SyncLogLevel;
  message: string;
};

function read(): SyncLogEntry[] {
  try {
    const parsed = safeParseJson<unknown>(
      typeof window !== 'undefined' ? window.localStorage.getItem(KEY) : null,
      null
    );
    return Array.isArray(parsed) ? (parsed as SyncLogEntry[]) : [];
  } catch {
    return [];
  }
}

/** Append a Classroom sync–related line (ring buffer, newest first). */
export function appendSyncLog(
  entry: Omit<SyncLogEntry, 'id' | 'at'> & { at?: number }
): SyncLogEntry[] {
  if (typeof window === 'undefined') return read();
  const id = `s_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  const at = entry.at ?? Date.now();
  const next: SyncLogEntry[] = [
    { id, at, level: entry.level, message: entry.message.trim() || '—' },
    ...read(),
  ].slice(0, MAX_ENTRIES);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* quota */
  }
  return next;
}

export function getSyncLogEntries(): SyncLogEntry[] {
  return read()
    .filter((e) => e && typeof e.id === 'string' && typeof e.at === 'number')
    .sort((a, b) => b.at - a.at);
}

export function clearSyncLog(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
